export default "/_next/static/images/header-bg-5a13cc4cb863dbe2b9a56e26d94df2cb.png";